import { mix, observable, watch } from "@chorda/core";
export const withParentScrollTop = (props) => {
    return mix({
        defaults: {
            parentScrollTop: () => observable(null)
        },
        joints: {
            initParentScrollTop: ({ $dom, parentScrollTop }) => {
                let scrollListeners = [];
                const listener = (e) => {
                    if (e) {
                        scrollListeners.forEach(l => {
                            if (l.target == e.target) {
                                l.scroll = e.target.scrollTop;
                            }
                        });
                    }
                    parentScrollTop.$value = scrollListeners.reduce((scroll, l) => scroll + l.scroll, 0);
                };
                watch(() => {
                    if ($dom.$value) {
                        parents($dom.$value).forEach(el => {
                            el.addEventListener('scroll', listener);
                            scrollListeners.push({ target: el, scroll: el.scrollTop });
                        });
                        listener();
                    }
                    else {
                        scrollListeners.forEach(l => {
                            l.target.removeEventListener('scroll', listener);
                        });
                    }
                }, [$dom]);
            }
        }
    }, props);
};
const parents = (el) => {
    const out = [];
    let parent = el.parentElement;
    while (parent != null) {
        out.push(parent);
        parent = parent.parentElement;
    }
    return out;
};
